export default __webpack_public_path__ + "static/media/referral_status_2.70cd5eb0.svg";